import React from 'react';


export default function CommunicationIcon() {
  return (
   <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.3337 4C25.3337 4 28.0003 5.6 28.0003 9.33333C28.0003 13.0667 25.3337 14.6667 25.3337 14.6667M22.667 6.66667C22.667 6.66667 24.0003 7.46667 24.0003 9.33333C24.0003 11.2 22.667 12 22.667 12M24.0003 28V25.3333C24.0003 23.9188 23.4384 22.5623 22.4382 21.5621C21.438 20.5619 20.0815 20 18.667 20H8.00033C6.58584 20 5.22928 20.5619 4.22909 21.5621C3.2289 22.5623 2.66699 23.9188 2.66699 25.3333V28M18.667 9.33333C18.667 12.2789 16.2792 14.6667 13.3337 14.6667C10.3881 14.6667 8.00033 12.2789 8.00033 9.33333C8.00033 6.38781 10.3881 4 13.3337 4C16.2792 4 18.667 6.38781 18.667 9.33333Z" stroke="#071013" strokeOpacity="0.5" strokeLinejoin="round"/>
</svg>

  )
}
